<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="人员管理">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-icon name="replay" size="24" @click="reset"/>
        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item v-model="flag" :options="flagOption" @change="handleSearch(nickname, flag)" />
      </van-dropdown-menu>
      <van-search clearable placeholder="请输入微信昵称"
                  v-model="nickname" @search="handleSearch(nickname, flag)" />
    </div>

    <div class="apply-body" ref="root">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无人员数据" />
        <van-cell-group v-if="dataList.length > 0">
          <van-swipe-cell v-for="data in dataList" :key="data">
            <van-cell :key="data" @click="clickPeople(data)">
              <template #title>
                <van-row align="center">
                  <van-col style="display: flex;align-items: center;">
                    <img :src="data['headimgurl']" class="user-imgurl"/>
                  </van-col>
                  <van-col offset="1">
                    <span>{{ data['nickname'] }}</span>
                  </van-col>
                </van-row>
              </template>
              <template #label>
                <van-row>
                  <span>最后登录时间：{{ parseTimeStr(data['updatetime']) }}</span>
                </van-row>
              </template>
              <template #value>
                <van-row justify="end">
                  <span>{{ data['companyName'] }}</span>
                </van-row>
              </template>
            </van-cell>
            <template #left>
              <van-button style="height: 100%" square type="success" icon="manager-o" text="设为管理员"
                          @click="toManagerForm(data)"
                          v-if="data['flag'] === -1"/>
              <van-button style="height: 100%" square type="danger" icon="manager-o" text="取消管理员"
                          @click="handleCancelManager(data)"
                          v-if="data['flag'] === 1"/>
            </template>
<!--            <template #right>
              <van-button style="height: 100%" square type="primary" icon="newspaper-o" text="添加简历"
                          v-if="data['flag'] === -1"/>
            </template>-->
          </van-swipe-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {cancelManager, getPeopleList} from "@/api";
import {showConfirmDialog, showNotify} from "vant";
import {parseTime} from "@/api/common";

export default {
  name: "UserManageList",
  data() {
    return {
      loading: true,
      dataList: [],
      nickname: '',
      flag: '-1',
      flagOption: [
        { text: '普通用户', value: '-1' },
        { text: '管理员', value: '1' },
      ],
    }
  },
  mounted() {
    let flag = window.sessionStorage.getItem('flag');
    if (flag === null || flag === undefined || flag === 'undefined') {
      this.flag = '-1';
    } else {
      this.flag = flag;
    }
    this.handleSearch(this.nickname, this.flag);
  },
  methods: {
    goBack() {
      window.sessionStorage.removeItem('flag');
      window.history.back();
    },
    reset() {
      this.nickname = '';
      this.handleSearch(this.nickname, this.flag);
    },
    parseTimeStr(time, pattern) {
      return parseTime(time, pattern);
    },
    handleSearch(nickname, flag) {
      this.loading = true;
      getPeopleList('nickname=' + nickname + '&flag=' + flag).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data;
          this.loading = false;
        } else {
          showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
        }
      });
    },
    clickPeople(data) {
      if (data['flag'] === 1) {
        this.toManagerForm(data)
      }
    },
    toManagerForm(data) {
      window.sessionStorage.setItem('peopleInfo', JSON.stringify(data));
      window.sessionStorage.setItem('flag', this.flag);
      this.$router.push('/ManagerForm');
    },
    handleCancelManager(data) {
      showConfirmDialog({
        message: '是否确认取消该管理员？',
      }).then(() => {
        cancelManager('userId=' + data['id']).then((res) => {
          if (res.code === 200) {
            showNotify({ type: 'success', message: '管理员取消成功！', position: 'bottom' });
            this.reset();
          } else {
            showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
          }
        });
      }).catch(() => {
        // on cancel
      });

    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cell__title {
  min-width: 75%;
}

/deep/ .van-cell__value {
  min-width: 25%;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-swipe-cell:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: var(--van-padding-md);
  bottom: 0;
  left: var(--van-padding-md);
  border-bottom: 1px solid var(--van-cell-border-color);
  transform: scaleY(.5);
}

.user-imgurl {
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
}
</style>